module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_fails.js
// module id = 14
// module chunks = 48 49 50 51